/** Tabs primárias (pill) — evita quebra em telas ~390px (iPhone 12). */
export const primaryPageTabClassName =
  'h-11 min-w-0 flex-1 px-2 text-sm font-semibold whitespace-nowrap sm:px-4 sm:text-base';

/** Tabs secundárias (underline). */
export const secondaryPageTabClassName =
  'h-9 min-w-0 flex-1 px-1.5 text-xs font-medium whitespace-nowrap sm:px-3 sm:text-sm';
